import React from 'react';
import { UiInputGroupWr } from "../../../../../_uiComponents/common/form/UiInputComponents";
import { Grid } from "@mui/material";
import Button from '@mui/material/Button';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import UiInput from "../../../../_uiComponents/UiInput";
import UiSwitch from "../../../../_uiComponents/UiSwitch"
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from '@mui/material/Stack';
import UiCropFileUpload from '../../../../../_uiComponents/common/form/UiCropFileUpload';
import {
    UiButton,
    UiBackButton,
    UiIconButton
} from "../../../../../_uiComponents/common/form/UiButton";
import ContentRevision from './ContentRevision'


export default function Content(props) {

    return (
        <>
            <UiInputGroupWr
                title="Header Content"
            >
                <div className='sbm-content-section'>
                    <Grid container spacing={2} sx={{ pb: 1 }}>
                        <Grid
                            item
                            xs="12"
                            lg="6"
                        >
                            <UiInput
                                type="text"
                                label="Header Title"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs="12"
                            lg="6"
                        >
                            <UiInput
                                label="Header Description"
                                multiline={true}
                                minRows={3}
                                maxRows={5} />
                        </Grid>

                        <Grid
                            item
                            xs="12"
                            lg="9"
                        >

                            <UiCropFileUpload aspectRatio={2 / 1} minWidth="746" label="Header Banner"
                                uploadSize="Min. image size 746px x 350px" />
                        </Grid>
                        
                            <Grid
                                item
                                xs="12"
                                lg="6"
                                className='sba-campaign-content-text-bg'
                            >
                                <UiInput
                                    type="text"
                                    label="Change Reason "
                                />
                            </Grid>
                    
                        <Grid item xs="12" lg="12" sx={{ mb: 2 }} >
                            <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                                <UiButton name="Clear" variant="outlined" size="small" />
                                <UiButton name="Save" variant="contained" size="small" />
                            </Stack>
                        </Grid>
                    </Grid>
                </div>
                <label className='sba-content-label'>Content Revision</label>
                <ContentRevision />
            </UiInputGroupWr>

            <UiInputGroupWr
                title="About the campaign"
            >
                <div className='sbm-content-section'>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs="12"
                            lg="6"
                        >
                            <UiInput
                                type="text"
                                label="Menu Title"
                            />
                        </Grid>

                        <Grid
                            item
                            xs="12"
                            lg="12"
                        >

                            <Grid container spacing={2}>
                                <Grid
                                    item
                                    xs="12"
                                    lg="6"
                                >
                                    <UiInputGroupWr
                                        title="Section 01"
                                    >
                                        <Grid container spacing={1}>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    label="Title"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiCropFileUpload aspectRatio={3 / 2} minWidth="320" label="Image 01"
                                                    uploadSize="Min. image size 320px x 240px" />
                                            </Grid>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    multiline={true}
                                                    minRows={3}
                                                    maxRows={5}
                                                    label="Description" />
                                            </Grid>
                                        </Grid>
                                    </UiInputGroupWr>
                                </Grid>
                                <Grid
                                    item
                                    xs="12"
                                    lg="6"
                                >
                                    <UiInputGroupWr
                                        title="Section 02"
                                    >
                                        <Grid container spacing={1}>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    label="Title"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiCropFileUpload aspectRatio={3 / 2} minWidth="320" label="Image 02"
                                                    uploadSize="Min. image size 320px x 240px" />
                                            </Grid>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    multiline={true}
                                                    minRows={3}
                                                    maxRows={5}
                                                    label="Description" />
                                            </Grid>
                                        </Grid>
                                    </UiInputGroupWr>
                                </Grid>
                                <Grid
                                    item
                                    xs="12"
                                    lg="6"
                                >
                                    <UiInputGroupWr
                                        title="Section 03"
                                    >
                                        <Grid container spacing={1}>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    label="Title"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiCropFileUpload aspectRatio={3 / 2} minWidth="320" label="Image 03"
                                                    uploadSize="Min. image size 320px x 240px" />
                                            </Grid>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    multiline={true}
                                                    minRows={3}
                                                    maxRows={5}
                                                    label="Description" />
                                            </Grid>
                                        </Grid>
                                    </UiInputGroupWr>
                                </Grid>
                                <Grid
                                    item
                                    xs="12"
                                    lg="6"
                                >
                                    <UiInputGroupWr
                                        title="Section 04"
                                    >
                                        <Grid container spacing={1}>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    label="Title"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiCropFileUpload aspectRatio={3 / 2} minWidth="320" label="Image 04"
                                                    uploadSize="Min. image size 320px x 240px" />
                                            </Grid>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    multiline={true}
                                                    minRows={3}
                                                    maxRows={5}
                                                    label="Description" />
                                            </Grid>
                                        </Grid>
                                    </UiInputGroupWr>
                                </Grid>

                            </Grid>
                        </Grid>


                        <Grid item xs="12" lg="12" sx={{ mb: 2 }} >
                            <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                                <UiButton name="Clear" variant="outlined" size="small" />
                                <UiButton name="Save" variant="contained" size="small" />
                            </Stack>
                        </Grid>
                    </Grid>
                </div>
                <label className='sba-content-label'>Content Revision</label>
                <ContentRevision />
            </UiInputGroupWr >

            <UiInputGroupWr
                title="Quick read content"
            >
                <div className='sbm-content-section'>
                    <Grid container spacing={2} sx={{ mb: 1 }}>
                        <Grid
                            item
                            xs="12"
                            lg="6"
                        >
                            <UiInput
                                type="text"
                                label="Title"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs="12"
                            lg="6"
                        >
                            <UiInput
                                type="text"
                                label="Description"
                                multiline={true}
                                minRows={3}
                                maxRows={5}
                            />
                        </Grid>


                        <Grid
                            item
                            xs="12"
                            lg="12"
                        >

                            <Grid container spacing={2}>
                                <Grid
                                    item
                                    xs="12"
                                    lg="4"
                                >
                                    <UiInputGroupWr
                                        title="Step 01"
                                    >
                                        <Grid container spacing={1}>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    label="Title"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    label="Description"
                                                    multiline={true}
                                                    minRows={3}
                                                    maxRows={5}
                                                />
                                            </Grid>
                                        </Grid>
                                    </UiInputGroupWr>
                                </Grid>
                                <Grid
                                    item
                                    xs="12"
                                    lg="4"
                                >
                                    <UiInputGroupWr
                                        title="Step 02"
                                    >
                                        <Grid container spacing={1}>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    label="Title"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    label="Description"
                                                    multiline={true}
                                                    minRows={3}
                                                    maxRows={5}
                                                />
                                            </Grid>
                                        </Grid>
                                    </UiInputGroupWr>
                                </Grid>
                                <Grid
                                    item
                                    xs="12"
                                    lg="4"
                                >
                                    <UiInputGroupWr
                                        title="Success"
                                    >
                                        <Grid container spacing={1}>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    label="Title"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs="12"
                                                lg="12"
                                            >
                                                <UiInput
                                                    type="text"
                                                    label="Description"
                                                    multiline={true}
                                                    minRows={3}
                                                    maxRows={5}
                                                />
                                            </Grid>
                                        </Grid>
                                    </UiInputGroupWr>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs="12" lg="12" sx={{ mb: 2 }} >
                            <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                                <UiButton name="Clear" variant="outlined" size="small" />
                                <UiButton name="Save" variant="contained" size="small" />
                            </Stack>
                        </Grid>
                    </Grid>
                </div>
                <label className='sba-content-label'>Content Revision</label>
                <ContentRevision />
            </UiInputGroupWr>
            <UiInputGroupWr
                title="Terms and condition content"
            >
                <div className='sbm-content-section'>
                    <Grid container spacing={2} xs={{ mb: 1 }}>
                        <Grid
                            item
                            xs="12"
                            lg="6"
                        >
                            <UiInput
                                type="text"
                                label="Menu Title"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} xs={{ mb: 1 }}>
                        <Grid
                            item
                            xs="12"
                            lg="6"
                        >
                            <UiInput
                                type="text"
                                label="Title"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs="12"
                            lg="6"
                        >
                            <UiInput
                                type="text"
                                label="Description"
                                multiline={true}
                                minRows={3}
                                maxRows={5}
                            />
                        </Grid>
                    </Grid>
                        <Grid container spacing={2}>
                            <Grid
                                item
                                xs="12"
                                lg="7"
                            >

                                <UiCropFileUpload aspectRatio={3.5 / 4} minWidth="350" label="Banner"
                                    uploadSize="Min.image size 350px x 400px" />
                            </Grid>
                        </Grid>
                    
                    <div className='sba-dynamic-content-row'>
                        <UiInputGroupWr
                            title="Terms and condition "
                        >
                            <Grid container spacing={2} sx={{ mb: 1 }}>
                                <Grid
                                    item
                                    xs="12"
                                    lg="6"
                                >
                                    <UiInput
                                        type="text"
                                        label="Title"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ mb: 1 }}>
                                <Grid
                                    item
                                    xs="12"
                                    lg="6"
                                >
                                    <UiInput
                                        type="text"
                                        label="Description"
                                        multiline={true}
                                        minRows={3}
                                        maxRows={5}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} >
                                <Grid
                                    item
                                    xs="12"
                                    lg="6"
                                >
                                    <FormControlLabel control={
                                        <UiSwitch />}
                                        label="Active"
                                        labelPlacement="top"
                                        sx={{ mt: 2 }}
                                        className='sba-campaign-switch-label' />

                                </Grid>
                            </Grid>
                        </UiInputGroupWr>
                        <Grid item xs="12" lg="12" sx={{ mb: 2 }} >
                            <Stack spacing={2} direction="row" justifyContent="start" sx={{ width: '100%' }}>
                                <Button variant="contained" color="success" startIcon={<ControlPointIcon />}>Add</Button>
                                <Button variant="contained" color="error" startIcon={<RemoveCircleOutlineIcon />}>
                                    Remove
                                </Button>
                            </Stack>
                        </Grid>
                    </div>
                    <Grid item xs="12" lg="12" sx={{ mb: 2, mt: 6 }} >
                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                            <UiButton name="Clear" variant="outlined" size="small" />
                            <UiButton name="Save" variant="contained" size="small" />
                        </Stack>
                    </Grid>
                </div>
                <label className='sba-content-label'>Content Revision</label>
                <ContentRevision />
            </UiInputGroupWr>
            <UiInputGroupWr
                title="FAQ content"
            >
                <div className='sbm-content-section'>
                    <Grid container spacing={2} xs={{ mb: 1 }}>
                        <Grid
                            item
                            xs="12"
                            lg="6"
                        >
                            <UiInput
                                type="text"
                                label="Menu Title"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} xs={{ mb: 1 }}>
                        <Grid
                            item
                            xs="12"
                            lg="6"
                        >
                            <UiInput
                                type="text"
                                label="Title"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} >
                        <Grid
                            item
                            xs="12"
                            lg="6"
                        >
                            <UiInput
                                type="text"
                                label="Description"
                                multiline={true}
                                minRows={3}
                                maxRows={5}
                            />
                        </Grid>

                    </Grid>
                    <div className='sba-dynamic-content-row'>
                        <UiInputGroupWr
                            title="FAQ "
                        >
                            <Grid container spacing={2} sx={{ mb: 1 }}>
                                <Grid
                                    item
                                    xs="12"
                                    lg="6"
                                >
                                    <UiInput
                                        type="text"
                                        label="Title"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ mb: 1 }}>
                                <Grid
                                    item
                                    xs="12"
                                    lg="6"
                                >
                                    <UiInput
                                        type="text"
                                        label="Description"
                                        multiline={true}
                                        minRows={3}
                                        maxRows={5}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid
                                    item
                                    xs="12"
                                    lg="6"
                                >
                                    <FormControlLabel control={
                                        <UiSwitch />}
                                        label="Active"
                                        labelPlacement="top"
                                        sx={{ mt: 2 }}
                                        className='sba-campaign-switch-label' />

                                </Grid>
                            </Grid>
                        </UiInputGroupWr>
                        <Grid item xs="12" lg="12" sx={{ mb: 2 }} >
                            <Stack spacing={2} direction="row" justifyContent="start" sx={{ width: '100%' }}>
                                <Button variant="contained" color="success" startIcon={<ControlPointIcon />}>Add</Button>
                                <Button variant="contained" color="error" startIcon={<RemoveCircleOutlineIcon />}>
                                    Remove
                                </Button>
                            </Stack>
                        </Grid>
                    </div>
                    <Grid item xs="12" lg="12" sx={{ mb: 2, mt: 6 }} >
                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                            <UiButton name="Clear" variant="outlined" size="small" />
                            <UiButton name="Save" variant="contained" size="small" />
                        </Stack>
                    </Grid>
                </div>
                <label className='sba-content-label'>Content Revision</label>
                <ContentRevision />
            </UiInputGroupWr>

        </>
    )
}
